/* Shopify and the browser own validation, CAPTCHA, POST and result messages. */
(() => {
  const tag = 'illustrators-contact-feedback';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      const form = this.querySelector('form.il-contact__form');
      const label = form?.querySelector('[data-contact-label]');
      const pending = form?.querySelector('[data-contact-pending]');
      if (!form) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      // Keep a fragment arrival at this panel while fonts/reviews above settle.
      // Any visitor input immediately gives scrolling back to the visitor.
      this.stopArrival = () => {
        this.arrivalEvents?.abort();
        this.arrivalObserver?.disconnect();
        clearTimeout(this.arrivalTimer);
        cancelAnimationFrame(this.arrivalFrame);
      };
      const startArrival = () => {
        this.stopArrival();
        let anchor;
        try { anchor = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const hasResult = form.querySelector('.il-contact__success, .il-form-message--error');
        if (!hasResult && (!anchor || (anchor !== form.id && anchor !== this.id))) return;
        if (this.contains(document.activeElement)) return;
        this.arrivalEvents = new AbortController();
        const arrivalOptions = { signal: this.arrivalEvents.signal };
        const align = () => {
          cancelAnimationFrame(this.arrivalFrame);
          this.arrivalFrame = requestAnimationFrame(() => {
            if (this.isConnected && !this.arrivalEvents.signal.aborted) {
              this.scrollIntoView({ block: 'start', behavior: 'instant' });
            }
          });
        };
        for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin']) {
          document.addEventListener(type, this.stopArrival, { ...arrivalOptions, capture: true, passive: true });
        }
        this.arrivalObserver = new ResizeObserver(align);
        this.arrivalObserver.observe(document.body);
        window.addEventListener('load', align, arrivalOptions);
        window.addEventListener('resize', align, arrivalOptions);
        document.fonts?.ready.then(() => {
          if (!this.arrivalEvents?.signal.aborted) align();
        });
        this.arrivalTimer = setTimeout(this.stopArrival, 10000);
        align();
      };
      window.addEventListener('hashchange', startArrival, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.stopArrival();
        else startArrival();
      }, options);
      startArrival();
      if (!label || !pending) return;
      this.resetFeedback = () => {
        form.removeAttribute('data-state');
        form.removeAttribute('aria-busy');
        label.hidden = false;
        pending.hidden = true;
      };
      // Observe a valid native submit without cancelling, replacing or locking it.
      form.addEventListener('submit', () => {
        form.dataset.state = 'pending';
        form.setAttribute('aria-busy', 'true');
        label.hidden = true;
        pending.hidden = false;
      }, { ...options, capture: true });
      form.addEventListener('input', this.resetFeedback, options);
      form.addEventListener('focusin', this.resetFeedback, options);
      window.addEventListener('pageshow', this.resetFeedback, options);
      this.resetFeedback();
    }
    disconnectedCallback() {
      this.stopArrival?.();
      this.resetFeedback?.();
      this.events?.abort();
      this.events = null;
      this.resetFeedback = null;
      this.stopArrival = null;
    }
  });
})();
